import React from 'react';

export const CheckboxIndeterminateIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <rect width="24" height="24" rx="4" fill="#16C47F" />
        <line x1="4.98218" y1="11" x2="19.0178" y2="11" stroke="white" strokeWidth="2" />
    </svg>
);
